export const USER_REQUEST_DATA = 'USER/REQUEST_DATA';
export const USER_BEGIN_WRITE_DATA = 'USER/BEGIN_WRITE_DATA';
export const USER_COMPLETE_WRITE_DATA = 'USER/COMPLETE_WRITE_DATA';
export const RECEIVE_USERS = 'USER/RECEIVE_USERS';
export const REMOVE_USER = 'USER/REMOVE_USER';
export const SET_THEME_PREFERENCE = 'USER/SET_THEME_PREFERENCE';
export const SET_OOO_RANGES = 'USER/SET_OOO_RANGES';
